import React from "react";
const OpenSourceUpsellWrapper = ({ children }) => /* @__PURE__ */ React.createElement(React.Fragment, null, children);
export default OpenSourceUpsellWrapper;
